module.exports = require("./ja-JP");